import { render, staticRenderFns } from "./PlanesForm.vue?vue&type=template&id=6c36ab8e&scoped=true"
import script from "./PlanesForm.vue?vue&type=script&lang=js"
export * from "./PlanesForm.vue?vue&type=script&lang=js"
import style0 from "./PlanesForm.vue?vue&type=style&index=0&id=6c36ab8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c36ab8e",
  null
  
)

export default component.exports